class i4_Lazyload {
	constructor(element) {
		this.element = element;

		this.data = {
			loaded: false,
			src: this.element.dataset.src,
			srcset: this.element.dataset.srcset ? this.element.dataset.srcset : this.element.dataset.src + ' 1x',
			minHeight: this.element.style.minHeight
		};

		this.events = {
		  loaded: 'i4-lazyload'
    };
	}

	init() {
		if ('IntersectionObserver' in window) {
			// modern way: intersection observer
			this.attachIntersectionObserver();
		}  else {
			// legacy way: check offset
			this.attachLegacyScrollListener();
		}
	}

	attachIntersectionObserver() {
		// intersection observer requires that object is higher than 0px (this may not be the case when using pading-bottom to show image in fixed aspect ratio)
		if (this.element.clientHeight === 0) {
			this.element.style.minHeight = '1px';
		}

		const observer = new IntersectionObserver(entries => {
			// isIntersecting is true when element and viewport are overlapping
			// isIntersecting is false when element and viewport don't overlap
			if(entries[0].isIntersecting === true) {
				this.loadImage();
				this.element.style.minHeight = this.data.minHeight;
				observer.disconnect();
			}
		}, { threshold: [0] });

		observer.observe(this.element);
	}

	/**
	 * check if the lazy-load image is in viewport
	 * @returns {boolean}
	 */
	inViewport() {

		return (this.element.getBoundingClientRect().top <= window.innerHeight && this.element.getBoundingClientRect().bottom >= 0);
	}

	/**
	 * check if the lazy-load image is <img> tag
	 * @returns {boolean}
	 */
	isImageTag() {

		return this.element.tagName.toLowerCase() === 'img';
	}

	/**
	 * load the image src / srcset
	 */
	loadImage() {
		if (!this.data.loaded) {
			if (this.isImageTag()) {

			  // dispatch a load event on document once the lazy image has been loaded so that other js can hook in
        let me = this;
        this.element.onload = function () {
          let event = new Event(me.events.loaded);
          document.dispatchEvent(event);
        };

				try {
					this.element.src = this.data.src;
					this.element.srcset = this.data.srcset;
					this.data.loaded = true;
				} catch (e) {
					this.data.loaded = false;
					console.log(this.data.src);
					console.log(this.data.srcset);
				}
			} else {
				// todo: how to deal with srcset when setting bg-image as css prop?
				this.element.style.backgroundImage = `url('${this.data.src}')`;
			}
		}
	}

	attachLegacyScrollListener() {
		if (this.inViewport()) {
			this.loadImage();
		} else {
			document.addEventListener("scroll", this.$onViewportChange.bind(this));
			window.addEventListener("resize", this.$onViewportChange.bind(this));
			window.addEventListener("orientationchange", this.$onViewportChange.bind(this));
		}
	}

	$onViewportChange() {
		if (this.inViewport()) {
			this.loadImage();
			document.removeEventListener("scroll", this.$onViewportChange);
			window.removeEventListener("resize", this.$onViewportChange);
			window.removeEventListener("orientationchange", this.$onViewportChange);
		}
	}


}
